export const GET_INTERNAL_ACCOUNT_LIST = 'GET_INTERNAL_ACCOUNT_LIST';
export const GET_INTERNAL_ACCOUNT_LIST_SUCCESS = 'GET_INTERNAL_ACCOUNT_LIST_SUCCESS';
export const GET_INTERNAL_ACCOUNT_LIST_FAILED = 'GET_INTERNAL_ACCOUNT_LIST_FAILED';

export const CREATE_INTERNAL_ACCOUNT = 'CREATE_INTERNAL_ACCOUNT';
export const CREATE_INTERNAL_ACCOUNT_SUCCESS = 'CREATE_INTERNAL_ACCOUNT_SUCCESS';
export const CREATE_INTERNAL_ACCOUNT_FAILED = 'CREATE_INTERNAL_ACCOUNT_FAILED';

export const UPDATE_INTERNAL_ACCOUNT = 'UPDATE_INTERNAL_ACCOUNT';
export const UPDATE_INTERNAL_ACCOUNT_SUCCESS = 'UPDATE_INTERNAL_ACCOUNT_SUCCESS';
export const UPDATE_INTERNAL_ACCOUNT_FAILED = 'UPDATE_INTERNAL_ACCOUNT_FAILED';

export const GET_INTERNAL_ACCOUNT_DETAIL = 'GET_INTERNAL_ACCOUNT_DETAIL';
export const GET_INTERNAL_ACCOUNT_DETAIL_SUCCESS = 'GET_INTERNAL_ACCOUNT_DETAIL_SUCCESS';
export const GET_INTERNAL_ACCOUNT_DETAIL_FAILED = 'GET_INTERNAL_ACCOUNT_DETAIL_FAILED';
export const RESET_INTERNAL_ACCOUNT_DETAIL = 'RESET_INTERNAL_ACCOUNT_DETAIL';

export const DELETE_INTERNAL_ACCOUNT = 'DELETE_INTERNAL_ACCOUNT';
export const DELETE_INTERNAL_ACCOUNT_SUCCESS = 'DELETE_INTERNAL_ACCOUNT_SUCCESS';
export const DELETE_INTERNAL_ACCOUNT_FAILED = 'DELETE_INTERNAL_ACCOUNT_FAILED';
